import type { FortuneIconProps } from '@/app_components/icons/constants';

export const ButtonRight = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      fill='none'
      height='12'
      viewBox='0 0 7 12'
      width='7'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Right Arrow Button Icon</title>
      <path
        d='M1 11L6 6L1 1'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.25'
      />
    </svg>
  );
};
